(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sw-enquiry-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = () => {
      document.querySelectorAll('.sw-enq__form').forEach((form) => {
        if (form.dataset.swReady) return;
        form.dataset.swReady = 'true';

        const multis = [...form.querySelectorAll('[data-sw-multi]')].map((group) => {
          const boxes = [...group.querySelectorAll('input[type="checkbox"]')];
          const sink = group.querySelector('[data-sw-multi-value]');
          const error = group.querySelector('.sw-enq__group-error');
          if (!sink || boxes.length === 0) return null;

          sink.name = boxes[0].name;
          boxes.forEach((box) => box.removeAttribute('name'));

          const sync = () => {
            sink.value = boxes
              .filter((box) => box.checked)
              .map((box) => box.value)
              .join(', ');
            if (error && sink.value) error.hidden = true;
          };

          boxes.forEach((box) => box.addEventListener('change', sync));
          sync();

          return { group, boxes, sink, error };
        });

        const tradeOnly = [...form.querySelectorAll('[data-sw-trade-only]')];
        const tradeRadio = form.querySelector('[data-sw-trade]');

        if (tradeRadio && tradeOnly.length > 0) {
          const syncTrade = () => {
            tradeOnly.forEach((field) => {
              field.hidden = !tradeRadio.checked;
              field.querySelectorAll('input').forEach((input) => {
                input.required = tradeRadio.checked;
              });
            });
          };
          form
            .querySelectorAll('input[name="contact[enquiry_type]"]')
            .forEach((radio) => radio.addEventListener('change', syncTrade));
          syncTrade();
        }

        form.addEventListener('submit', (event) => {
          const honeypot = form.querySelector('[name="sw_hp"]');
          if (honeypot && honeypot.value !== '') {
            event.preventDefault();
            return;
          }

          const empty = multis.find(
            (multi) => multi && multi.group.hasAttribute('data-sw-required') && !multi.sink.value
          );
          if (empty) {
            event.preventDefault();
            if (empty.error) empty.error.hidden = false;
            empty.boxes[0].focus();
          }
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
